
import { ThemeOptions } from "@mui/material/styles";

declare module '@mui/material/styles' {
    interface TypeText {
        warning: string;
    }
}

export const DefaultThemeOptions: ThemeOptions = {
    typography: {
        fontFamily: 'Montserrat, sans-serif',
        h1: {
            fontSize: '2.5rem'
        },
        h2: {
            fontSize: '2.0rem',
            fontWeight: '400',
            color: '#eee'
        },
        h3: {
            fontSize: '1.3rem'
        },
        h4: {
            fontSize: '1.25rem',
            color: '#eee'
        },
        h5: {
            fontSize: '1.2rem',
            color: '#eee'
        },
        h6: {
            fontSize: '1.1rem',
            color: '#eee'
        },
        body1: {
            fontSize: '1.0rem',
            fontWeight: '400'
        },
        body2: {
            fontSize: '0.9rem',
        }
    },
    palette: {
        text: {
            warning: '#CC3300'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 992,
            lg: 1250,
            xl: 1536,
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                // This is where we fix Google Autocomplete z-index
                '.pac-container': {
                    zIndex: 2000, // increase if your input is inside a Dialog/Drawer
                }
            }
        }
    }
}

export default DefaultThemeOptions;